import { AuthenticatedUser } from "@services/user/types";
import { findDynamicPathAccess } from "./findDynamicPathAccess";
import { hasNoPermission } from "./hasNoPermission";
import { DynamicPathAccess } from "./types";

const reportPathPermissions: DynamicPathAccess[] = [
  {
    pathRegex: /^\/bi\/reports\/(Reports_Audit.*|meetings.*)/,
    permissionKey: "meetings",
  },
  {
    pathRegex: /^\/bi\/reports\/(Reports_Users.*|users.*)/,
    permissionKey: "users",
  },
];

export const hasNoPermissionToViewReport = (
  user: AuthenticatedUser,
  path: Location["pathname"]
) => {
  const reportPermissionKey = findDynamicPathAccess(
    path,
    reportPathPermissions,
    "permissionKey"
  );

  if (!reportPermissionKey) return false;

  return hasNoPermission(user, reportPermissionKey);
};
